import { render, staticRenderFns } from "./DomiciliaryDetail.vue?vue&type=template&id=5c2216ee&"
import script from "./DomiciliaryDetail.vue?vue&type=script&lang=js&"
export * from "./DomiciliaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports